module.exports = __webpack_public_path__ + "static/header-image-05-e781c6baa0fa458b86601777832b6905.png";